import * as ko from "knockout";
import {ButtonManager} from "../../util/ButtonManager";
import {
    getBackButton,
    getCancelButton,
    getContinueButton,
    getExitButton,
    getNextButton
} from "../../constants/RouteDefinitions";
import {ICompany, ICompanySyncstep, IMessageData} from "../../index";
import {global, lm} from "../../appContext";
import PromiseRequest from "../../req/PromiseRequest";
import {PLEASE_WAIT_MESSAGE} from "../../constants/Language";
import {nsSyncStatus} from "@component/system/nsSyncStatus";
import {createErrorMessage} from "../../util/misc";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import execute_syncstepHtml from './execute-syncstep.html?raw';

export const template = execute_syncstepHtml

enum Step {
    Init = 1,
    Form,
    Process,
    Complete,
}

export class viewModel {

    private company!: ICompany
    private readonly Step = Step
    private readonly _messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private readonly css: KnockoutObservable<ICompanySyncstep | null> = ko.observable(null)
    private readonly id: ICompanySyncstep['id'];
    private readonly ispartoffullsync: KnockoutObservable<boolean> = ko.observable(false);
    private readonly kosub = new KOSubscriptionTracker()
    private readonly pageButtons: ButtonManager = new ButtonManager()
    private readonly req_executesyncstep = new PromiseRequest('executesyncstep')
    private readonly req_getcompany = new PromiseRequest('getcompany')
    private readonly runscriptblock: KnockoutObservable<boolean> = ko.observable(true);
    private readonly step: KnockoutObservable<Step | null> = ko.observable(null)

    constructor() {
        this.id = global.getRouteId()

        this.pageButtons.add(getCancelButton(undefined, {
            validator: () => this.step() != Step.Complete,
        }))
        this.pageButtons.add(getExitButton(undefined, {
            validator: () => this.step() == Step.Complete,
        }))
        this.pageButtons.add(getContinueButton({
            onClick: () => this.step(Step.Process),
            validator: () => this.step() == Step.Form,
        }))

        this.kosub.subscribe(this.step, step => {
            if (step != null) {
                this.onStepChange(step)
            }
        })
        this.step(Step.Init)
    }

    private heading = ko.pureComputed(() => {
        let key = `executesyncstep.heading.${this.step()}`

        if (lm.hasTranslation(key)) {
            return lm.t(key)
        } else {
            return null
        }
    })

    private messageData = ko.pureComputed(() => {
        if (this._messageData()) {
            return this._messageData()
        } else {
            const key: string = `executesyncstep.info.${this.step()}`

            if (lm.hasTranslation(key)) {
                return {
                    message: lm.t({
                        k: key,
                        br: true,
                        obj: {
                            company: this.company,
                            css: this.css,
                        },
                    })
                }
            } else {
                return null
            }
        }
    })

    private onStepChange(step: Step) {
        this._messageData(null)
        switch (step) {
            case Step.Init: {
                this._messageData({message: PLEASE_WAIT_MESSAGE})
                this.req_getcompany.request()
                    .then((data: [ICompany]) => {
                        this.company = data[0]
                        const css = this.company.syncsteps?.find(o => o.id == this.id) ?? null;
                        this.css(css)
                        const selectedCss = this.css();
                        if (!selectedCss) {
                            throw ('Synchronization step not found')
                        }
                        const a = nsSyncStatus.isExecuteSyncstepAvailable(this.company, selectedCss, global.permissionValidator.role())
                        const b = nsSyncStatus.isExecuteSyncstepEnabled(this.company, selectedCss)
                        if (!a || !b) {
                            throw ('Synchronization step can not be executed')
                        } else {
                            this.step(Step.Form)
                        }
                    })
                    .catch((reason: string) => {
                        this.step(null)
                        this._messageData(createErrorMessage(String(reason)))
                    })
                break
            }
            case Step.Form: {
                break
            }
            case Step.Process: {
                this._messageData({message: PLEASE_WAIT_MESSAGE})
                const params = {
                    id: this.id,
                    ispartoffullsync: this.ispartoffullsync(),
                    runscriptblock: this.runscriptblock(),
                }
                this.req_executesyncstep.request(params)
                    .then(() => {
                        this.step(Step.Complete)
                    })
                    .catch((reason: string) => {
                        this.step(null)
                        this._messageData(createErrorMessage(String(reason)))
                    })
                break
            }
            case Step.Complete: {
                break
            }
        }
    }

    dispose() {
        this.req_getcompany.abort()
        this.req_executesyncstep.abort()
    }

}